import { FC, useEffect, useState } from "react";
import { getContinuousPurchasePrice } from "../../../lib/auctions/gda/continuous";
import AuctionBase from "../AuctionBase";
import React from "react";
import moment from "moment";
import { Auction } from "../../../types";

interface GDAContinousAuctionProps {
  auction: Auction;
  now: number;
  endEpoch: number;
  customerId: string;
  shopLoginUrl: string;
  onPlaceBid: (price: number, quantity: number) => void;
  currentPrice: number;
  setCurrentPrice: (num: number) => void;
  statefulPurchaseQuantity: number;
  setStatefulPurchaseQuantity: (num: number) => void;
  setVariant: (variant: number) => void;
}

export const GDAContinousAuction: FC<GDAContinousAuctionProps> = ({
  auction,
  now,
  endEpoch,
  customerId,
  shopLoginUrl,
  onPlaceBid,
  currentPrice,
  setCurrentPrice,
  setStatefulPurchaseQuantity,
  statefulPurchaseQuantity,
  setVariant,
}) => {
  const [loggedIn, setLoggedIn] = useState(false);

  const [timeLeft, setTimeLeft] = useState(auction.last_epoch);
  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(Math.floor(timeLeft - 1));
        if (timeLeft % 2 === 0) {
          const epoch = new Date().getTime() / 1000;
          const price = getContinuousPurchasePrice(
            auction.starting_price,
            auction.decay_rate,
            auction.emission_rate,
            Math.floor(epoch) - auction.last_epoch,
            statefulPurchaseQuantity ? 1 : Number(statefulPurchaseQuantity)
          );
          setCurrentPrice(price);
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, auction, setCurrentPrice, statefulPurchaseQuantity]);

  return (
    <AuctionBase
      auction={auction}
      targetDate={timeLeft}
      currentPrice={currentPrice}
      onBidClick={onPlaceBid}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setVariant={setVariant}
    />
  );
};
